import TextField from "@material-ui/core/TextField";
import {formatToExponential} from "../../../../helpers/NumberHelper";
import Grid from "@material-ui/core/Grid";
import React from "react";
import PipeCard from "../../../pipe-common/PipeCard";

const defaultIndicators = {
    frequency: "---",
    powerLevel: "---",
    trim: "---",
    summaryAlarmStatus: "UNAVAILABLE",
    rfInhibitStatus: "UNAVAILABLE",
    overrideRfInhibitStatus: "UNAVAILABLE"
};

export default function PeakComARU2856CReadBack({pipe, data}) {
    const indicators = data
        ? Object.assign(defaultIndicators, {
            summaryAlarmStatus: data["summary_alarm_status"] || defaultIndicators.summaryAlarmStatus,
            powerLevel: data["power_level"] || defaultIndicators.powerLevel,
            rfInhibitStatus: data["rf_inhibit_status"] || defaultIndicators.rfInhibitStatus,
            overrideRfInhibitStatus: data["override_rf_inhibit_status"] || defaultIndicators.overrideRfInhibitStatus,
            frequency: data["frequency"] || defaultIndicators.frequency,
            trim: data["trim"] || defaultIndicators.trim,
        }) : defaultIndicators;

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"row"} justify={"center"} alignItems={"center"} spacing={2}>
                    <Grid item>
                        <TextField
                            id="frequency"
                            label="Frequency"
                            value={formatToExponential(indicators.frequency)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="power-level"
                            label="Power Level"
                            value={formatToExponential(indicators.powerLevel)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="trim"
                            label="Trim"
                            value={formatToExponential(indicators.trim)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="summary-alarm-status"
                            label="Summary Alarm Status"
                            value={indicators.summaryAlarmStatus}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="rf-inhibit-status"
                            label="Rf Inhibit Status"
                            value={indicators.rfInhibitStatus}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="override-rf-inhibit-status"
                            label="Override Rf Inhibit Status"
                            value={indicators.overrideRfInhibitStatus}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                </Grid>
            }
        />
    );
}